<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-6">
                        <ul class="breadcrumb">
                            <li><a href="#" title="Home">Home</a></li>
                            <li><a href="#" title="Pages">Gerencial</a></li>
                            <li>Parâmetro</li>
                        </ul>
                    </section>
                    <section class="col-sm-6">
                        <!--<button class="btn-large-40 btn-success uppercase pull-right btn-header" @click="openCreate()">
                            Criar
                        </button>-->
                    </section>
                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Parâmetro</b></h2>
                    </div>

                    <div class="mold-txt-center">
                        <form v-on:submit.prevent="executeFilter(filter)">
                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label for="chave">Chave</label>
                                    <input type="text" class="form-control" name="chave" placeholder="Chave" v-model="filter.chave" />
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="descricao">Descrição</label>
                                    <input type="text" class="form-control" name="descricao" placeholder="Descricao" v-model="filter.descricao" />
                                </div>
                            </div>
                            <button type="button" class="btn-large-40 btn-red uppercase" @click="executeFilter(filter)">Buscar</button>
                        </form>
                    </div>

                    <div class="table-responsive standard-table header-cinza">
                        <table>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Chave<i @click="executeOrderBy('Chave')" class="fa fa-sort"></i></th>
                                    <th>Descrição<i @click="executeOrderBy('Descricao')" class="fa fa-sort"></i></th>
                                    <th>Módulo</th>
                                    <th>Valor Padrão<i @click="executeOrderBy('ValorPadrao')" class="fa fa-sort"></i></th>


                                    <th class="text-center" width="150"><i class="fa fa-cog"></i></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in result.items" v-bind:key="item.tagJobsId" class="animated fadeIn">
                                    <td>{{ item.parametroId }}</td>
                                    <td>{{ item.chave }}</td>
                                    <td>{{ item.descricao }}</td>
                                    <td>{{ item.modulo ? item.modulo.nome : item.moduloId }}</td>
                                    <td>
                                        {{ item.valorPadrao }}
                                        <i v-if="item.parametroId == parametroIdInatividade" class="fa fa-exclamation-circle" aria-hidden="true" v-b-tooltip.hover.right title="Esse item contempla a quantidade de minutos que um usuário pode permanecer inativo no sistema."></i>
                                    </td>

                                    <td class="text-center">
                                        <button type="button" class="btn btn-sm btn-warning" @click="openEdit({ parametroId: item.parametroId })">
                                            <i class="fa fa-cog"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-primary" @click="openParamsLog(item.parametroId)">
                                            <i class="fa fa-search"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="card-block no-padding">
                        <pagination :total="result.total" :page-size="filter.pageSize" :callback="executePageChanged"></pagination>
                    </div>

                </div>
            </div>
        </section>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogCreate" :hide-footer="true" title="Criar">
            <form-create v-if="dialogCreate" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogEdit" :hide-footer="true" title="Editar">
            <form-edit v-if="dialogEdit" :id="parametroId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogRemove" title="Confirmação">
            <p>Tem certeza que deseja remover este item?</p>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeRemove()">
                    Remover
                </button>
            </div>
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogParamsLog" title="LOG PARÂMETROS DO FRANQUEADOR">
            <div class="table-responsive standard-table header-cinza">
                <table v-if="paramsModel">
                    <thead>
                        <tr>
                            <th>Data  e Horário</th>
                            <th>Ação</th>
                            <th>Usuário</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in paramsModel" v-bind:key="item.parametroId" class="animated fadeIn">
                            <td>{{item.data}}</td>
                            <td>{{item.descricao}}</td>
                            <td>{{item.colaborador ? item.colaborador.nmCompleto : item.colaboradorId}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="dialogParamsLog = !dialogParamsLog">
                    Fechar
                </button>
            </div>
        </b-modal>

    </main>

</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'
    import global from '@/common/global'
    import formCreate from './form-create'
    import formEdit from './form-edit'

    export default {
        name: 'parametro',
        mixins: [base],
        components: { formCreate, formEdit },
        data() {
            return {

                resources: {
                    filter: 'parametro',
                    remove: 'parametro'
                },

                dialogRemove: false,
                dialogCreate: false,
                dialogEdit: false,
                dialogParamsLog: false,

                paramsModel: {},
                model: {},
                filter: {
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                },

                result: {
                    total: 0,
                    items: []
                },
                parametroIdInatividade: global.PARAMETRO_TEMPO_DE_INATIVIDADE
            }
        },
        methods: {
            openEdit: function (model) {
                this.parametroId = model.parametroId;
                this.dialogEdit = true;
            },
            openCreate: function () {
                this.dialogCreate = true;
            },
            onSaved: function () {
                this.hideAll();
                this.executeLoad();
            },
            hideAll: function () {
                this.dialogCreate = false;
                this.dialogEdit = false;
                this.dialogRemove = false;
            },

            openRemove: function (model) {
                this.dialogRemove = true;
                this.model = model;
            },

            openParamsLog: function (parametroId) {
                this.showLoading();
                new Api("LogAlteracaoSistema/GetLogParametrosFranqueador").get({ AuxiliarId: parametroId, OrderFields: 'Data', OrderByType: 1, TipoLogAlteracaoSistemaId: 12 }).then(data => {
                    this.dialogParamsLog = true;
                    this.paramsModel = data.data.dataList;
                    this.hideAll();
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })

            },
            executeRemove: function (model) {
                if (model) this.model = model;
                new Api(this.resources.remove).delete(this.model).then(() => {
                    this.defaultSuccessResult("Item removido com sucesso");
                    this.hideAll();
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            executeFilter: function (filter) {
                if (filter) this.filter = filter;
                this.executeLoad();
            },
            executePageChanged: function (index) {
                this.filter = this.defaultPageChanged(this.filter, index);
                this.executeLoad();
            },
            executeOrderBy: function (field) {
                this.filter = this.defaultOrderBy(this.filter, field);
                this.executeLoad();
            },
            executeLoad: function () {
                this.showLoading();
                new Api(this.resources.filter).get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;
                    this.result.items = data.dataList;
                    console.log("this.result.items", this.result.items);
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },

        },

        mounted() {
            this.executeFilter();
        }

    };
</script>